// extracted by mini-css-extract-plugin
export var filterIncDec = "_d3-0";
export var leftBorder = "_d3-1";
export var rightBorder = "_d3-2";
export var stringInput = "_d3-3";